module.exports = __webpack_public_path__ + "images/order-ee6c851b05.svg";